<template>
    <div class="dashboard-push">
        <div>
            <typo name="title-30-normal">La veille juridique</typo>
            <sep name="S" />
            <typo name="body-16-normal">Consulter les dernières veilles juridiques Maladie - Prévoyance.</typo>
        </div>
        <sep name="L" />
        <push-item
            v-for="push in user.pushes"
            :key="push.id"
            :push="push"
        ></push-item>
    </div>
</template>

<script>
import PushItem from "../push/PushItem";

export default {
    components: { PushItem },
    props: ["user"],
};
</script>

<style scoped lang="sass">

.dashboard-push
    padding: $grid-gutter * 1.5 0
</style>
